import type { RenderComponentProps } from "replo-runtime/shared/types";

import React from "react";

import { ReploComponent } from "../../ReploComponent";

export const BundleHeader: React.FC<RenderComponentProps> = ({
  componentAttributes,
  component,
  context,
}) => {
  return (
    <div {...componentAttributes}>
      {component.children?.map((child) => (
        <ReploComponent key={child.id} context={context} component={child} />
      ))}
    </div>
  );
};
